const API_URL = window.ArmaTuPCConfig?.apiUrl || process.env.REACT_APP_API_URL;

const fetchProds = async (currentStep, setProducts, filterProds, setSteps, setFProducts, setIsLoading) => {
    let categoryId;

    if(typeof currentStep.category_id === "object")
        categoryId = currentStep.category_id.join(',');
    else
        categoryId = currentStep.category_id;

    await fetch(`${API_URL}/productos/${categoryId}`, {
        headers: {
            'Content-type': 'application/json'
        },
        method: 'GET'
    }).then(async response => {
        let prods = await response.json();

        setProducts(prevProds => [
            ...prevProds,
            {id: currentStep.category_id, data: prods}
        ]);

        // filterProds({...currentStep, data: prods}, setSteps, setFProducts, setIsLoading);
    });
}

export default fetchProds;